import { useState } from "react";
import { format, add, sub } from "date-fns";
import { CalculoCuota, InsertCuotas, SumaExcedentes } from "../../../../functions/FunctionCuota";
import { useEffect } from "react";
import "../../../shared/styles/UnifiedTable.css";

const DetalleCuota = ({
  data, onClick, onChange
}) => {
  let deuda = 0.00;
  let resto = 0.0;
  let excedente_pago = null;

  const [detalles, setDetalles] = useState(null);


  useEffect(() => {
    setDetalles(data)
  },[data])
  return (
    <div className="unified-table-container">
      <table className="unified-table">
        <thead>
          <tr>
            <th className="text-center"><div>Nº Cuota</div></th>
            <th className="text-center"><div>Vto</div></th>
            <th className="text-center"><div>Capital</div></th>
            <th className="text-center"><div>Intereses</div></th>
            <th className="text-center"><div>Importe</div></th>
            <th className="text-center"><div>Días de mora</div></th>
            <th className="text-center"><div>Int Punitorio</div></th>
            <th className="text-center"><div>Total a pagar</div></th>
            <th className="text-center"><div>Deuda acumulada</div></th>
            <th className="text-center"><div>Estado</div></th>
            <th className="text-center"><div>Acciones</div></th>
          </tr>
        </thead>
      <tbody>

        {
        detalles
        ?detalles.map((cuota, index) => (
          <>
            <tr key={index}>
              <td className="text-center">{index + 1}</td>
              <td className="text-center">
                {format(
                  new Date(
                    cuota.fecha_vencimiento_concesion
                      ? cuota.fecha_vencimiento_concesion+" 00:00:00"
                      : cuota.fecha_vencimiento+" 00:00:00"
                  ),
                  "dd/MM/yyyy"
                ).toString()}
              </td>
              <td className="text-end">
                <span className="unified-money">
                  ${" "}
                  {new Intl.NumberFormat("es-AR").format(cuota.capital)}
                </span>
              </td>
              <td className="text-end">
                <span className="unified-money">
                  ${" "}
                  {new Intl.NumberFormat("es-AR").format(cuota.interes)}
                </span>
              </td>
              <td className="text-end">
                <span className="unified-money">
                  $ {new Intl.NumberFormat("es-AR").format(cuota.total)}
                </span>
              </td>
              <td className="text-center">
                <span className={CalculoCuota(cuota).diferencia_moratoria > 0 ? "unified-badge unified-badge-warning" : "unified-badge unified-badge-secondary"}>
                  {CalculoCuota(cuota).diferencia_moratoria} días
                </span>
              </td>
              <td className="text-end">
                <span className={CalculoCuota(cuota).original_interes_punitorio > 0 ? "unified-money-negative" : "unified-money"}>
                  $ {new Intl.NumberFormat("es-AR").format(CalculoCuota(cuota).original_interes_punitorio.toFixed(2))}
                </span>
              </td>
              <td className="text-end">
                <span className="unified-money">
                  {"$ "+new Intl.NumberFormat("es-AR").format(CalculoCuota(cuota).deuda.toFixed(2))}
                </span>
              </td>
              <td className="text-end">
                <span className="d-none">{deuda =  CalculoCuota(cuota, JSON.parse(excedente_pago)).deuda + deuda}</span>
                <span className="unified-money">
                  {"$ "+new Intl.NumberFormat("es-AR").format(deuda.toFixed(2))}
                </span>
              </td>
              <td className="text-center">
                {
                parseFloat(deuda).toFixed(1) <= 0 ? (
                  <span className="unified-badge unified-badge-success">Cancelado</span>
                ) : (
                  <span className="unified-badge unified-badge-warning">Pendiente</span>
                )}
              </td>
              <td className="text-center">
                <div className="accordion accordion-flush">
                  <div className="accordion-item border-0">
                    <h2 className="accordion-header" id={"flush-headingOne" + index}>
                      <label
                       className="btn btn-sm"
                       style={{
                         background: 'linear-gradient(135deg, #155E75 0%, #0F3D4A 100%)',
                         color: '#FFFFFF',
                         border: 'none',
                         borderRadius: '8px',
                         padding: '6px 12px',
                         fontSize: '0.85rem',
                         fontWeight: '600',
                         cursor: 'pointer',
                         transition: 'all 0.2s ease'
                       }}
                       onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                       onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                      >
                        <i className="bi bi-list-ul me-1"></i>Ver Pagos
                      <button
                       className="d-none"
                       type="button"
                       data-bs-toggle="collapse"
                       data-bs-target={"#flush-collapseOne" + index}
                       aria-expanded="false"
                      >
                      </button>
                    </label>
                    </h2>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan={11} style={{ padding: '16px', background: 'transparent', border: 'none' }}>
                <div className="accordion accordion-flush">
                  <div className="accordion-item border-0" style={{ background: 'transparent' }}>
                    <div
                      id={"flush-collapseOne" + index}
                      className="accordion-collapse collapse"
                    >
                      <div className="accordion-body" style={{
                        padding: '0',
                        background: '#FFFFFF',
                        borderRadius: '12px',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                        overflow: 'hidden'
                      }}>
                        <div style={{
                          background: 'linear-gradient(135deg, #F8FAFC 0%, #F1F5F9 100%)',
                          padding: '12px 20px',
                          borderBottom: '2px solid #E2E8F0'
                        }}>
                          <strong style={{ color: '#1E293B', fontSize: '0.95rem' }}>
                            <i className="bi bi-cash-stack me-2"></i>Detalle de Pagos - Cuota {index + 1}
                          </strong>
                        </div>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                          <thead style={{ background: '#F8FAFC' }}>
                            <tr>
                              <th style={{ padding: '12px', textAlign: 'left', color: '#64748B', fontSize: '0.85rem', fontWeight: '700', borderBottom: '1px solid #E2E8F0' }}>Fecha</th>
                              <th style={{ padding: '12px', textAlign: 'left', color: '#64748B', fontSize: '0.85rem', fontWeight: '700', borderBottom: '1px solid #E2E8F0' }}>Tipo</th>
                              <th style={{ padding: '12px', textAlign: 'left', color: '#64748B', fontSize: '0.85rem', fontWeight: '700', borderBottom: '1px solid #E2E8F0' }}>Forma de pago</th>
                              <th style={{ padding: '12px', textAlign: 'right', color: '#64748B', fontSize: '0.85rem', fontWeight: '700', borderBottom: '1px solid #E2E8F0' }}>Importe</th>
                              <th style={{ padding: '12px', textAlign: 'right', color: '#64748B', fontSize: '0.85rem', fontWeight: '700', borderBottom: '1px solid #E2E8F0' }}>Int Punit.</th>
                              <th style={{ padding: '12px', textAlign: 'right', color: '#64748B', fontSize: '0.85rem', fontWeight: '700', borderBottom: '1px solid #E2E8F0' }}>Interes</th>
                              <th style={{ padding: '12px', textAlign: 'right', color: '#64748B', fontSize: '0.85rem', fontWeight: '700', borderBottom: '1px solid #E2E8F0' }}>Capital</th>
                              <th style={{ padding: '12px', textAlign: 'center', color: '#64748B', fontSize: '0.85rem', fontWeight: '700', borderBottom: '1px solid #E2E8F0' }}>Acción</th>
                            </tr>
                          </thead>
                          <tbody>
                            {InsertCuotas(cuota.pagos, JSON.parse(excedente_pago)).map((pago, indexPago) => (
                              <tr key={indexPago} style={{ borderBottom: '1px solid #F1F5F9' }}>
                                <td style={{ padding: '10px 12px', fontSize: '0.85rem', color: '#1E293B' }}>
                                  {format(
                                    new Date(pago.fecha_importe+" 00:00:00"), "dd/MM/yyyy"
                                  ).toString()}
                                </td>
                                <td style={{ padding: '10px 12px', fontSize: '0.85rem', color: '#1E293B' }}>
                                  {pago.estado}
                                </td>
                                <td style={{ padding: '10px 12px', fontSize: '0.85rem', color: '#1E293B' }}>
                                  {pago.forma_pago}
                                </td>
                                <td style={{ padding: '10px 12px', fontSize: '0.85rem', color: '#059669', fontWeight: '600', textAlign: 'right' }}>
                                  {"$ " + new Intl.NumberFormat("es-AR").format(pago.importe)}
                                </td>
                                <td style={{ padding: '10px 12px', fontSize: '0.85rem', textAlign: 'right' }}>-</td>
                                <td style={{ padding: '10px 12px', fontSize: '0.85rem', textAlign: 'right' }}>-</td>
                                <td style={{ padding: '10px 12px', fontSize: '0.85rem', textAlign: 'right' }}>-</td>
                                <td style={{ padding: '10px 12px', textAlign: 'center' }}>
                                  {pago.id == parseInt(data.id_ultimo_pago) ? (
                                    <label className="btn btn-sm"
                                      style={{
                                        background: 'linear-gradient(135deg, #DC2626 0%, #B91C1C 100%)',
                                        color: '#FFFFFF',
                                        border: 'none',
                                        borderRadius: '8px',
                                        padding: '6px 12px',
                                        fontSize: '0.75rem',
                                        fontWeight: '600',
                                        cursor: 'pointer'
                                      }}
                                    >
                                      <i className="bi bi-lock me-1"></i>Cancelar
                                      <button
                                        className="d-none"
                                        name="delete_payment"
                                        onClick={(event) => onClick(event, pago)}
                                        title="Se necesita clave de administrador para esa acción"
                                      ></button>
                                    </label>
                                  ) : (
                                    <span>-</span>
                                  )}
                                </td>
                              </tr>
                            ))}
                            <tr style={{ background: 'linear-gradient(135deg, #F8FAFC 0%, #E2E8F0 100%)', fontWeight: '700' }}>
                              <td colSpan={3} style={{ padding: '12px', borderTop: '2px solid #E2E8F0', color: '#1E293B', fontWeight: '700' }}>
                                TOTAL
                              </td>
                              <td style={{ padding: '12px', borderTop: '2px solid #E2E8F0', color: '#059669', fontWeight: '700', textAlign: 'right' }}>
                                {"$ " + new Intl.NumberFormat("es-AR").format(CalculoCuota(cuota, JSON.parse(excedente_pago)).pagos)}
                              </td>
                              <td style={{ padding: '12px', borderTop: '2px solid #E2E8F0', color: '#dc2626', fontWeight: '700', textAlign: 'right' }}>
                                {"$ " + new Intl.NumberFormat("es-AR").format(CalculoCuota(cuota, JSON.parse(excedente_pago)).interes_punitorio)}
                              </td>
                              <td style={{ padding: '12px', borderTop: '2px solid #E2E8F0', color: '#059669', fontWeight: '700', textAlign: 'right' }}>
                                {"$ " + new Intl.NumberFormat("es-AR").format(CalculoCuota(cuota, JSON.parse(excedente_pago)).interes)}
                              </td>
                              <td colSpan={2} style={{ padding: '12px', borderTop: '2px solid #E2E8F0', color: '#059669', fontWeight: '700', textAlign: 'right' }}>
                                {"$ " + new Intl.NumberFormat("es-AR").format(CalculoCuota(cuota, JSON.parse(excedente_pago)).capital)}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </>
                                  ))
        : ""
        }
      </tbody>
    </table>
  </div>
  )
}

export default DetalleCuota